import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Alert, Box } from "@mui/material";
import LoadingSpinner from "components/basic/loadingSpinner";
import Tabs from "components/basic/tabs";
import useUrlParamState from "hooks/useUrlParamState";
import TicketDetail from "pages/dashboard/pages/support/components/TicketDetail";
import TicketList from "pages/dashboard/pages/support/components/TicketList";
import { SUPPORT_TABS } from "pages/dashboard/pages/support/constants";
import { filterByTab } from "pages/dashboard/pages/support/helpers";
import { useTickets } from "pages/dashboard/pages/support/supportApi";
import { TabKey } from "pages/dashboard/pages/support/types";

/** Every user's and vendor's tickets, answered as the support team. */
const SupportTab: React.FC = () => {
  const { t } = useTranslation("support");
  const [selectedTab, setSelectedTab] = useState<TabKey>("open");
  const [ticketParam, setTicketParam] = useUrlParamState("ticket");
  const { tickets, loading, error } = useTickets(true);

  const selectedId = ticketParam ? Number(ticketParam) : null;

  if (selectedId) {
    return (
      <Box height="100%">
        <TicketDetail
          key={selectedId}
          ticketId={selectedId}
          asAdmin
          onBack={() => setTicketParam(null)}
        />
      </Box>
    );
  }

  return (
    <Box>
      <Box py={1}>
        <Tabs
          selectedTab={selectedTab}
          setSelectedTab={(tab) => setSelectedTab(tab as TabKey)}
          tabs={SUPPORT_TABS.map((tab) => ({ ...tab, label: t(tab.label) }))}
          align="left"
        />
      </Box>
      {error ? (
        <Box px={3}>
          <Alert severity="error">{error}</Alert>
        </Box>
      ) : loading ? (
        <LoadingSpinner />
      ) : (
        <TicketList
          tickets={filterByTab(tickets, selectedTab)}
          emptyText="No tickets here."
          showRequester
          onSelect={(ticket) => setTicketParam(String(ticket.id))}
        />
      )}
    </Box>
  );
};

export default SupportTab;
